<template>
  <div class="content">
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 v-show="false" class="h2 text-white d-inline-block mb-0">
            Fluxo de caixa
          </h6>
          <nav
            v-show="false"
            aria-label="breadcrumb"
            class="d-none d-md-inline-block ml-md-4"
          ></nav>
        </b-col>
      </b-row>
    </base-header>
    <b-container  fluid class="mt--6">
      <div>
        <b-card no-body>
          <b-card-body>
            <b-card-title class="h3 mb-0">Período e filtros</b-card-title>
            <div class="mt-3" method="post" action="">
              <b-row>
                <b-col cols="12">
                  <validation-observer
                    v-slot="{ handleSubmit }"
                    ref="formValidator"
                  >
                    <form
                      class="needs-validation"
                      @submit.prevent="handleSubmit(fetchTransactions)"
                    >
                      <b-row class="form-group">
                        <b-col md="4">
                          <base-input
                            type="date"
                            v-model="formDate.startDate"
                            value=""
                            id="example-date-input"
                          />
                        </b-col>
                        <b-col md="4">
                          <base-input
                            type="date"
                            v-model="formDate.endDate"
                            value=""
                            id="example-date-input"
                          />
                        </b-col>
                        <b-row name class="pl-3"
                          >
                          <b-col>
                           <base-button
                              @click="showFilterSearch = !showFilterSearch"
                              icon
                              type="primary"
                              title="filtrar os resultados da busca"
                            >
                              <span 
                                class="btn-inner--icon"
                                ><i
                                  :class="
                                    showFilterSearch
                                      ? 'ni ni-bold-up'
                                      : 'ni ni-bold-down'
                                  "
                                ></i
                              ></span>
                            </base-button> 
                          </b-col>
                          <!--  -->
                          <b-col>
                            <button 
                              type="submit" 
                              class="btn btn-primary">
                              Buscar
                            </button>
                          </b-col>
                          </b-row
                        >
                      </b-row>
                    </form>
                    <form id="forSelec"
                      class="needs-validation"
                      @submit.prevent="handleSubmit(fetchFilterTransactions)"
                    >
                      <search-filter
                        ref='searchFilter'
                        :inputCategories="inputCategories"
                        :outputCategories="outputCategories"
                        :clients="clients"
                        :agents="agents"
                        :visible="showFilterSearch"
                        @categoriesSelected="setInputCategories"
                        @outCategoriesSelected="setOutputCategories"
                        @clientsSelected="setClients"
                        @agentsSelected="setAgents"
                      />
                      <b-row class="pl-12"
                        v-show="showFilterSearch"
                        >
                        <b-col>
                          <button style="float: right; top: 12px" 
                            type="submit" 
                            class="btn btn-primary right 100">
                            Aplicar Filtros
                          </button>
                        </b-col>
                      </b-row>
                    </form>
                  </validation-observer>
                </b-col>
              </b-row>
            </div>
          </b-card-body>
        </b-card>
      </div>
      <div>
        <b-card no-body style="min-height:180px" ref="day_by_day_wrapper">
          <b-card-body>
            <b-card-title class="h3 mb-0">Análise</b-card-title>
            <div class="col-lg-12" style="text-align: right;"></div>
            <el-tabs v-model="activeName">
              <el-tab-pane class="scroll" label="Histórico" name="first" 
                ><chart-dia-dia
                  :series="seriesChartDiaDia"
                  ref="chart_dia_dia"
                  :loading="loadingChartDiaDia"
                />
              </el-tab-pane>
              <el-tab-pane :lazy="true" label="Entradas" name="second">
                <b-row class="mt-3">
                  <b-col xs="12" lg="6" md="6">
                    <table-input-by-payment-method
                      :data="dataTableInputByPaymentMethod"
                      headerColor="bg-success pt-2 pb-2"
                      title="Formas de pagamento"
                    />
                  </b-col>
                  <b-col xs="12" lg="6" md="6" align="center"
                    ><pie-chart-financeiro 
                      :labels="dataTableInputByPaymentMethodLabels"
                      :series="dataTableInputByPaymentMethodSeries"
                    />
                  </b-col>
                </b-row>
              </el-tab-pane>
              <el-tab-pane :lazy="true" label="Saídas" name="third">
                <b-row class="mt-3">
                  <b-col xs="12" lg="6" md="6">
                    <table-output-by-categories
                      :data="dataTableOutputByCategories"
                      headerColor="bg-danger pt-2 pb-2"
                      title="Grupos de contas"
                    />
                  </b-col>
                  <b-col align="center" xs="12" lg="6" md="6"
                    ><pie-chart-financeiro
                      :labels="dataTableOutputByCategoryLabels"
                      :series="dataTableOutputByCategorySeries"
                    />
                  </b-col> 
                  </b-row
              ></el-tab-pane>
              <el-tab-pane :lazy="true" label="Comparativo" name="fourth">
                Comparativo
              </el-tab-pane>
              <!-- <el-tab-pane :lazy="true" label="DRE" name="fifth">
                <b-row>
                  <b-col>
                    <dre-financeiro
                      :inputDRE="inputDRE"
                      :outputDRE="outputDRE"
                    />
                  </b-col>
                </b-row>
              </el-tab-pane> -->
            </el-tabs>
          </b-card-body>
        </b-card>
      </div>
      <b-row>
        <b-col lg="6">
          <financeiro-table
            :data="inputTransactions"
            headerColor="bg-success pt-2 pb-2"
            title="Entradas "
          />
        </b-col>
        <b-col lg="6">
          <financeiro-output-table
            :data="outputTransactions"
            headerColor="bg-danger pt-2 pb-2"
            title="Saídas"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import "vue-good-table/dist/vue-good-table.css";

import ChartDiaDia from "./ChartDiaDia";
import PieChartFinanceiro from "./PieChartFinanceiro.vue";
// import DreFinanceiro from "./DreFinanceiro.vue";

import bocapioCakeService from "./../../services/cakephp/index";
import FinanceiroTable from "./FinanceiroTable.vue";
import { Tabs, TabPane } from "element-ui";
import TableInputByPaymentMethod from "./TableInputByPaymentMethod.vue";
import TableOutputByCategories from "./TableOutputByCategories.vue";
import FinanceiroOutputTable from "./FinanceiroOutputTable .vue"
//import OutputTable from "./OutputTable.vue"
import SearchFilter from "./SearchFilter.vue";

var axios = require("axios");

import transacoesFake from "./dataTesteTransacoes";
import { forEach } from "jszip";
import { json, keys, map } from "d3";
//const urlAgents = "http://apps-dev.bocapio.com.br/agents/json/list?&layout=ajax"
//const urlClients = "http://apps-dev.bocapio.com.br/clients/json/list?&layout=ajax"

export default {
  name: "Financial",
  components: {
    ChartDiaDia,
    TableInputByPaymentMethod,
    TableOutputByCategories,
    FinanceiroTable,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    SearchFilter,
    PieChartFinanceiro,
    //DreFinanceiro,
    FinanceiroOutputTable
  },
  props: {
    pageChanged: {
      type: Function
    },
    perPageChanged: {
      type: Function
    }
  },
  data() {
    return {
      formDate: {
        startDate: "2020-01-01",
        endDate: "2020-01-31"
      },

      inputCategories: [],
      outputCategories: [],

      //current place's payment methods list  
      dataTableInputByPaymentMethod: [],
      //current place's payment method labels list  
      dataTableInputByPaymentMethodLabels: [],
      //current place's payment method totals list  
      dataTableInputByPaymentMethodSeries: [],

      //current place's payment categories list  
      dataTableOutputByCategories: [],
      //current place's payment category labels list  
      dataTableOutputByCategoryLabels: [],
      //current place's payment category totals list  
      dataTableOutputByCategorySeries: [],

      cakeUserdata: null,
      cakeUserParams: null,

      showFilterSearch: false,

      activeName: "first",

      seriesChartDiaDia: [
        {
          name: "Entradas",
          type: "column",
          data: []
        },
        {
          name: "Saídas",
          type: "column",
          data: []
        },
        {
          name: "Saldo",
          type: "line",
          data: []
        }
      ],

      loadingChartDiaDia: false,

      perPage: 3,
      currentPage: 1,

      transactions: [],
      inputTransactions: [],
      outputTransactions: [],
      superArrayInputTransactions: [],
      superArrayOutputTransactions: [],
      loadingTransactions: false,
      superArray: [],
      requestArray: [],
      selectedCategories: [],
      selectedOutCategories: [],
      selectedClients: [],
      selectedAgents: [],
      clients: [],
      agents: [],
      agentsTemp: [],
      clientsTemp:[],
      clientsId: [],
      agentsId:[],
      responseInputFilter: [],
      responseOutputFilter: [],
      // inputDRE: [],
      // outputDRE: [],
       
    };
  },
  mounted() {
    this.fetchAgents(),
    this.fetchClients(),
    this.fetchTransactions();
    //this.fetchFilterTransactions();
    this.cakeUserdata = JSON.parse(localStorage.getItem("cakeuserdata"));
    //console.log("this.cakeUserdata", this.cakeUserdata);
    this.cakeUserParams = JSON.parse(this.cakeUserdata.user.params);
    this.inputCategories = this.cakeUserParams.User.transaction_input_categories || [];
    //console.log("this.inputCategories", this.inputCategories);
    //Input transactions category to bills
    this.inputCategories["Vendas"] = "Vendas";
    //Input transactions default
    this.inputCategories["Outros"] = "Outros";
    this.inputCategories = Object.values(this.inputCategories);
    //Output transactions default
    this.outputCategories = this.cakeUserParams.User.transaction_categories || [];
    this.outputCategories["Outros"] = "Outros";
    this.outputCategories = Object.values(this.outputCategories);
    //console.log("inputCategories", this.inputCategories);
    //console.log("outputCategories", this.outputCategories);

  },
  methods: {
    async fetchTransactions() {
      var { startDate: formStartDate, endDate: formEndDate } = this.formDate;
      var sDate = new Date(formStartDate);
      var eDate = new Date(formEndDate);

      if (sDate.getTime() > eDate.getTime()) {
        alert("Erro! a Data final deve ser após a data inicial !");
      }

      this.loadingTransactions = true;
      this.loadingChartDiaDia = true;
      this.superArrayOutputTransactions = [];
      this.superArrayInputTransactions = [];
      this.requestArray = [];

      this.fillRequestArray(formStartDate, formEndDate);
      
      
      //create input requests
      let inputPartialRequests = []
      this.requestArray.forEach((item)=>{
        inputPartialRequests.push(bocapioCakeService.getTransactions("1", item.start, item.end)) 
                    //this.selectedCategories, this.selectedOutCategories, this.selectedClients, this.selectedAgents 
      })
     //get all input requests 
      const responseInputTmp = await Promise.all(inputPartialRequests);
     //merge input request results 
      let responseInput = []
      responseInputTmp.forEach(resp=>{
        Array.prototype.push.apply(responseInput, resp.globalsearch)
      })
     
      //create output requests
      let outputPartialRequests = []
      this.requestArray.forEach((item)=>{
        outputPartialRequests.push(bocapioCakeService.getTransactions("0", item.start, item.end)) 
                                   // this.selectedCategories, this.selectedOutCategories, this.selectedClients, this.selectedAgents
      })

     //get all output requests 
      const responseOutputTmp = await Promise.all(outputPartialRequests);
      let responseOutput = []
     //merge output request results 
      responseOutputTmp.forEach(resp=>{
        Array.prototype.push.apply(responseOutput, resp.globalsearch)
      })
      //console.log("inputTransactions", responseInput);
      //console.log("outpuTransactions", responseOutput);

      this.inputTransactions = responseInput;
      this.outputTransactions = responseOutput;
      //console.log("inputTransactions", responseInput);
      //console.log("outpuTransactions", responseOutput);
      
      // this.inputTransactions = responseInput;
      // this.outputTransactions = responseOutput
      
      this.responseInputFilter = responseInput
      this.responseOutputFilter = responseOutput
      //console.log("this.selectedCategories", this.selectedCategories);
      //console.log("this.outCategoriesSelected", this.selectedOutCategories);
      //console.log("clientsSelected", this.selectedClients);
      //console.log("agentsSelected", this.selectedAgents);
      
      
      this.createSuperArrays(sDate, eDate);
      this.fillSuperArraysInput();
      this.fillSuperArraysOutput();
      this.fillTableInputByPaymentMethod();
      this.fillTableByCategories();
      this.updateCharts();
      // this.fillTableDreFinanceiro();
      //this.loadClientsAgents();
      //this.fillSelected();
      
     
      this.loadingTransactions = false;
      this.loadingChartDiaDia = false;
      // } catch (error) {
      //   alert("Erro ao carregar dados do servidor !");
      //   this.loadingTransactions = false;
      //   this.loadingChartDiaDia = false;
      // }
      
    },
    

    fillRequestArray(startDate, endDate) {
      const requestDateStep = 1
      let start = new Date(startDate)
      let end = new Date(endDate)
      let startAux = new Date(startDate)
      let currentMonth = startAux.toISOString().substr(0, 7)
      let requestObj = null
      while (startAux.getTime() < end.getTime()) {
        if (startAux.getTime() < end.getTime()) {
          if(currentMonth != startAux.toISOString().substr(0, 7)){
            currentMonth = startAux.toISOString().substr(0, 7)
            requestObj = {
              start: start.toISOString().substr(0, 10),
              end: (new Date(startAux.getUTCFullYear(), startAux.getUTCMonth(), 0)).toISOString().substr(0, 10)
            };
            this.requestArray.push(requestObj);
            start.setTime(startAux.getTime());
          }
        } 
        startAux.setDate(startAux.getDate() + requestDateStep);
      }
        requestObj = {
          start: start.toISOString().substr(0, 10),
          end: end.toISOString().substr(0, 10)
        };
        this.requestArray.push(requestObj);
        // console.log('Request array...',JSON.stringify(this.requestArray))
    },

    createSuperArrays(startDate, endDate) {
      let paymentMethodTemp = JSON.parse(localStorage.getItem("cakeuserdata"));
      let paymentMethods = paymentMethodTemp.paymentMethods;
      paymentMethods[0] = "Outros";

      //console.log("paymentMethods", paymentMethods);
      var keys = Object.keys(paymentMethods);
      //console.log("keys", keys);
      var values = new Array(keys.length).fill(0);
      //console.log("values", values);
      var byPaymentMethods = values.reduce(function(result, field, index) {
        result[keys[index]] = field;
        //console.log("result", result);
        return result;
      }, {});

      let byInputCategories = {};
      let pointerInput = byInputCategories;
      
      if(this.inputCategories.length){
        this.inputCategories.forEach(category => {
          let categories = category.split(": ");
          pointerInput = byInputCategories;
          for (let index = 0; index < categories.length; index++) {
            let subCategory = categories[index];
            if (pointerInput[subCategory] === undefined) {
              pointerInput[subCategory] = { total: 0 };
              let pointerSubcat = pointerInput[subCategory];
              categories.slice(index + 1).forEach(subcat => {
                pointerSubcat[subcat] = { total: 0 };
                pointerSubcat = pointerSubcat[subcat];
              });
              break;
            }
            pointerInput = pointerInput[subCategory];
          }
        })
      }
      
      //console.log('byInputCategories', JSON.stringify(byInputCategories));

      let byOutputCategories = {};
      let pointerOutput = byOutputCategories;

      this.outputCategories.forEach(category => {
        let categories = category.split(": ");
        pointerOutput = byOutputCategories;
        for (let index = 0; index < categories.length; index++) {
          let subCategory = categories[index];
          if (pointerOutput[subCategory] === undefined) {
            pointerOutput[subCategory] = { total: 0 };
            let pointerSubcat = pointerOutput[subCategory];
            categories.slice(index + 1).forEach(subcat => {
              pointerSubcat[subcat] = { total: 0 };
              pointerSubcat = pointerSubcat[subcat];
            });
            break;
          }
          pointerOutput = pointerOutput[subCategory];
        }
      });
      while (startDate.getTime() <= endDate.getTime()) {
        let start_date = startDate.toISOString().substr(0, 10);

        const oneDay = 1000 * 60 * 60 * 24;
        let current_date = startDate.getTime() + oneDay;

        // inputArray

        this.superArrayInputTransactions[start_date] = {};

        this.superArrayInputTransactions[
          start_date
        ].by_payment_metod = JSON.parse(JSON.stringify(byPaymentMethods));

        this.superArrayInputTransactions[start_date].by_payment_metod.total = 0;

        this.superArrayInputTransactions[start_date].by_categories = JSON.parse(
          JSON.stringify(byInputCategories)
        );

        this.superArrayInputTransactions[start_date].by_categories.total = 0;

        this.superArrayInputTransactions[start_date].total = 0;

        // outputArray

        this.superArrayOutputTransactions[start_date] = {};

        this.superArrayOutputTransactions[
          start_date
        ].by_payment_metod = JSON.parse(JSON.stringify(byPaymentMethods));

        this.superArrayOutputTransactions[
          start_date
        ].by_payment_metod.total = 0;

        this.superArrayOutputTransactions[
          start_date
        ].by_categories = JSON.parse(JSON.stringify(byOutputCategories));

        this.superArrayOutputTransactions[start_date].by_categories.total = 0;

        this.superArrayOutputTransactions[start_date].total = 0;
        startDate.setTime(current_date); // +1 dia
      }
      this.superArrayInputTransactions.total = 0;
      this.superArrayOutputTransactions.total = 0;
      //console.log('superArrayInputTransactions', this.superArrayInputTransactions)
      //console.log('superArrayOutputTransactions', this.superArrayOutputTransactions)
    },
    
    fillSuperArraysInput() {
      //mecher para filtrar
      this.inputTransactions.forEach(transaction => {
        //alterar transaction.p => transaction.d
        //inserir filtro aqui
        if (this.selectedClients.length > 0 || this.selectedCategories.length > 0) {
          //console.log("this.inputTransactions filtro", this.inputTransactions); 
          if (this.superArrayInputTransactions[transaction.p]) {
            //console.log("this.superArrayInputTransactions[transaction.p", this.superArrayInputTransactions[transaction.p]);
                  //total: period
            this.superArrayInputTransactions.total += parseFloat(transaction.v);
            //total: day
            this.superArrayInputTransactions[transaction.p].total += parseFloat(
              transaction.v
            );

            //payment_method: by method
            if (
              this.superArrayInputTransactions[transaction.p].by_payment_metod[
                transaction.pm
              ] !== undefined
            ) {
              this.superArrayInputTransactions[transaction.p].by_payment_metod[
                transaction.pm
              ] += parseFloat(transaction.v);
            } else {
              this.superArrayInputTransactions[transaction.p].by_payment_metod[
                "0"
              ] += parseFloat(transaction.v);
            }

            //payment_method: total
            this.superArrayInputTransactions[
              transaction.p
            ].by_payment_metod.total += parseFloat(transaction.v);

            //category: by category
            let cats = transaction.cat.split(": ");
            let pointerSubcat = this.superArrayInputTransactions[transaction.p]
              .by_categories;
            pointerSubcat.total += parseFloat(transaction.v);
            cats.forEach(subcat => {
              if (pointerSubcat[subcat] !== undefined) {
                pointerSubcat[subcat]["total"] += parseFloat(transaction.v);
              } else {
                pointerSubcat[subcat] = { total: parseFloat(transaction.v) };
              }
            });
          }
        
        }else {
          //console.log("Não entrou no filtro");
          if (this.superArrayInputTransactions[transaction.p]) {
            //console.log("this.superArrayInputTransactions[transaction.p", this.superArrayInputTransactions[transaction.p]);
                  //total: period
            this.superArrayInputTransactions.total += parseFloat(transaction.v);
            //total: day
            this.superArrayInputTransactions[transaction.p].total += parseFloat(
              transaction.v
            );

            //payment_method: by method
            if (
              this.superArrayInputTransactions[transaction.p].by_payment_metod[
                transaction.pm
              ] !== undefined
            ) {
              this.superArrayInputTransactions[transaction.p].by_payment_metod[
                transaction.pm
              ] += parseFloat(transaction.v);
            } else {
              this.superArrayInputTransactions[transaction.p].by_payment_metod[
                "0"
              ] += parseFloat(transaction.v);
            }

            //payment_method: total
            this.superArrayInputTransactions[
              transaction.p
            ].by_payment_metod.total += parseFloat(transaction.v);

            //category: by category
            let cats = transaction.cat.split(": ");
            let pointerSubcat = this.superArrayInputTransactions[transaction.p]
              .by_categories;
            pointerSubcat.total += parseFloat(transaction.v);
            cats.forEach(subcat => {
              if (pointerSubcat[subcat] !== undefined) {
                pointerSubcat[subcat]["total"] += parseFloat(transaction.v);
              } else {
                pointerSubcat[subcat] = { total: parseFloat(transaction.v) };
              }
            });
          }
        }
        
      });
    },

    fillSuperArraysOutput() {
      this.outputTransactions.forEach(transaction => {
        if (this.selectedOutCategories.length > 0 || this.selectedAgents.length > 0) {
          if (this.superArrayOutputTransactions[transaction.p]) {
          //total: period
          this.superArrayOutputTransactions.total += parseFloat(transaction.v);

          //total: day
          this.superArrayOutputTransactions[transaction.p].total += parseFloat(
            transaction.v
          );

          //payment_method: by method
          if (
            this.superArrayOutputTransactions[transaction.p].by_payment_metod[
              transaction.pm
            ] !== undefined
          ) {
            this.superArrayOutputTransactions[transaction.p].by_payment_metod[
              transaction.pm
            ] += parseFloat(transaction.v);
          } else {
            this.superArrayOutputTransactions[transaction.p].by_payment_metod[
              "0"
            ] += parseFloat(transaction.v);
          }

          //payment_method: total
          this.superArrayOutputTransactions[
            transaction.p
          ].by_payment_metod.total += parseFloat(transaction.v);

          //category: by category
          let cats = transaction.cat.split(": ");
          let pointerSubcat = this.superArrayOutputTransactions[transaction.p]
            .by_categories;
          pointerSubcat.total += parseFloat(transaction.v);
          cats.forEach(subcat => {
            if (pointerSubcat[subcat] !== undefined) {
              pointerSubcat[subcat]["total"] += parseFloat(transaction.v);
            } else {
              pointerSubcat[subcat] = { total: parseFloat(transaction.v) };
            }
            pointerSubcat = pointerSubcat[subcat];
          });
        }
        } else {
          if (this.superArrayOutputTransactions[transaction.p]) {
          //total: period
          this.superArrayOutputTransactions.total += parseFloat(transaction.v);

          //total: day
          this.superArrayOutputTransactions[transaction.p].total += parseFloat(
            transaction.v
          );

          //payment_method: by method
          if (
            this.superArrayOutputTransactions[transaction.p].by_payment_metod[
              transaction.pm
            ] !== undefined
          ) {
            this.superArrayOutputTransactions[transaction.p].by_payment_metod[
              transaction.pm
            ] += parseFloat(transaction.v);
          } else {
            this.superArrayOutputTransactions[transaction.p].by_payment_metod[
              "0"
            ] += parseFloat(transaction.v);
          }

          //payment_method: total
          this.superArrayOutputTransactions[
            transaction.p
          ].by_payment_metod.total += parseFloat(transaction.v);

          //category: by category 
          let cats = transaction.cat.split(": ");
          let pointerSubcat = this.superArrayOutputTransactions[transaction.p]
            .by_categories;
          pointerSubcat.total += parseFloat(transaction.v);
          cats.forEach(subcat => {
            if (pointerSubcat[subcat] !== undefined) {
              pointerSubcat[subcat]["total"] += parseFloat(transaction.v);
            } else {
              pointerSubcat[subcat] = { total: parseFloat(transaction.v) };
            }
            pointerSubcat = pointerSubcat[subcat];
          });
        }
        }
        
      });
      /*
      console.log(
        "superArrayOutputTransactions",
        JSON.stringify(this.superArrayOutputTransactions)
      );
      */
    },

    updateCharts() {
      // main chart (dia a dia)
      const chartLabels = Object.keys(this.superArrayOutputTransactions).filter(
        key => key != "total"
      );
      var outputSeries = [];
      var inputSeries = [];
      var avaregeSeries = [];

          //console.log("superArrayInputTransactions", this.superArrayInputTransactions);
      for (var transactionKey in this.superArrayOutputTransactions) {
          // insert input total value
          let totalIn = this.superArrayInputTransactions[transactionKey].total;
          if( totalIn ){
            inputSeries.push(totalIn)
          }else{
            inputSeries.push(0)
          }

          // insert output total value
          let totalOut = this.superArrayOutputTransactions[transactionKey].total;
          if( totalOut ){
            outputSeries.push(totalOut*-1);
          }else{
            outputSeries.push(0);
            
          }
          
          // insert avarege value
          var avarege =
            this.superArrayInputTransactions[transactionKey].total -
            this.superArrayOutputTransactions[transactionKey].total;

          if( avarege ){
            avaregeSeries.push(avarege)
          }else{
            avaregeSeries.push(avarege)
          }
      }

      // console.log("day_by_day_wrapper", this.$refs.day_by_day_wrapper.clientWidth);
      let newWidth = chartLabels.length*30
      newWidth = newWidth >this.$refs.day_by_day_wrapper.clientWidth ? newWidth : this.$refs.day_by_day_wrapper.clientWidth
      newWidth -= 80
      this.$refs.chart_dia_dia.width =  newWidth;
      this.$refs.chart_dia_dia.chartOptions.chart.animations.enabled =  (inputSeries.length < 60);
      this.$refs.chart_dia_dia.updateLabels(chartLabels);

      this.seriesChartDiaDia[0].data = inputSeries;
      this.seriesChartDiaDia[1].data = outputSeries;
      this.seriesChartDiaDia[2].data = avaregeSeries;
     

    },

    //Agrupa as entradas por forma de pagamento
    fillTableInputByPaymentMethod() {
      let paymentMethodTemp = JSON.parse(localStorage.getItem("cakeuserdata"));
      let widgetInputByPaymentMethod = [];
      widgetInputByPaymentMethod[0] = {paymentMethod:0, label:"Outros", value: 0, percent: 0};
      Object.keys(paymentMethodTemp.paymentMethods).forEach(pm => {
        widgetInputByPaymentMethod[pm] = {paymentMethod: pm, label:paymentMethodTemp.paymentMethods[pm], value: 0, percent: 0}
      });
      
      //widgetInputByPaymentMethod.sort((a, b) => (a.label > b.label) ? 1 : -1)
      Object.keys(this.superArrayInputTransactions).forEach(superKey => {        
        if (this.superArrayInputTransactions[superKey].by_payment_metod) {
          let dayPaymentMethods = this.superArrayInputTransactions[superKey].by_payment_metod;
          Object.entries(dayPaymentMethods).forEach(dayPaymentMethod => {
            let filteredpm = widgetInputByPaymentMethod[dayPaymentMethod[0]] ||  widgetInputByPaymentMethod[0]
            filteredpm ? (filteredpm.value += dayPaymentMethod[1]) : ""
          });
        }
      });

      let valueSum = widgetInputByPaymentMethod.map(({ value }) => value).reduce((sum, b) => sum + b)
      this.dataTableInputByPaymentMethodLabels = widgetInputByPaymentMethod.map(({ label }) => label)
      this.dataTableInputByPaymentMethodSeries = widgetInputByPaymentMethod.map(({ value }) => value)
     // console.log('valueSum',JSON.stringify(valueSum))
      
      this.dataTableInputByPaymentMethod = widgetInputByPaymentMethod;
    },

    fillTableByCategories() {
      // load output transactions categories from localStorage
      let byCategories = JSON.parse(localStorage.getItem("cakeuserdata"))
      byCategories = JSON.parse(byCategories['user']['params']);
      byCategories = byCategories['User']['transaction_categories'];
      byCategories = Object.keys(byCategories).map((cat)=>cat.split(':')[0])
      // filtering unique values
      byCategories = byCategories.filter((cat, index) => byCategories.indexOf(cat) == index)
      
      let widgetOutputByCategories = [];

      widgetOutputByCategories.push({label:"Outros", value: 0, percent: 0});
      Object.keys(byCategories).forEach((cat) => {
        widgetOutputByCategories.push({label:byCategories[cat], value: 0, percent: 0})
      });
      
      Object.keys(this.superArrayOutputTransactions).forEach(superKey => {
        if (this.superArrayOutputTransactions[superKey].by_categories) {
          let dayOutputCategories = this.superArrayOutputTransactions[superKey].by_categories;
          //console.log("dayOutputCategories 2", dayOutputCategories);
          Object.entries(dayOutputCategories).forEach(dayOutputCategory => {
            let filteredpm = widgetOutputByCategories.find(
              pm => pm.label === dayOutputCategory[0]
            );
            filteredpm ? (filteredpm.value += dayOutputCategory[1].total) : "";
          });
        }
      });
      
      this.dataTableOutputByCategories = widgetOutputByCategories
      this.dataTableOutputByCategoryLabels = widgetOutputByCategories.map(({ label }) => label)
      this.dataTableOutputByCategorySeries = widgetOutputByCategories.map(({ value }) => value)
    },
    setInputCategories(cats) { 
      this.selectedCategories = cats; 
      console.log("this.selectedCategories", this.selectedCategories);
    },
    setOutputCategories(outCats) {
      this.selectedOutCategories = outCats
      console.log("this.selectedOutCategories", this.selectedOutCategories);
    },
    setClients(cliente) {
      this.selectedClients = cliente
      console.log("this.selectedClients", this.selectedClients);
      
    },
    setAgents(agente) {
      this.selectedAgents = agente
      console.log("this.selectedAgents", this.selectedAgents);
      
    },
    fetchAgents() {
      //console.log("fetchAgents()");
      bocapioCakeService
        .getAjax('agents', 'list', '','GET','jsonp')
        .then((rsp) => {
          this.data = rsp.list;
         // console.log("agents", this.data);
          const agents = this.data.map(item => (item.n));
          this.agents = agents;
          this.loadAgents(this.data);
          //console.log("this.agents", this.agents);
          this.loading = false;
        })
    },
    fetchClients() {
      //console.log("fetchAgents()");
      bocapioCakeService
        .getAjax('clients', 'list', '','GET','jsonp')
        .then((rsp) => {
          this.data = rsp.list;
          //this.$emit('dadosClients', this.data)
          //console.log("clientes", this.data);
          const clients = this.data.map(item => (item.n));
          this.clients = clients;
          this.loadClients(this.data);
          //console.log("this.clients", this.clients);
          this.loading = false;
        })
    },
    async getMap() {
      return axios.get(`${process.env.VUE_APP_API_CAKE_URL}agents/json/map`);
    },
    async getMapClients() {
      return axios.get(`${process.env.VUE_APP_API_CAKE_URL}clients/json/map`);
    },
    
    loadAgents(array) {
      this.agentsTemp = array
      //console.log("array agents", this.agentsTemp);
      return this.agentsTemp;
    },
    loadClients(array) {
      this.clientsTemp = array
      //console.log("array clientes", this.clientsTemp);
      return this.clientsTemp;
    },
    fetchFilterTransactions() {
      this.inputTransactions = [];
      this.outputTransactions = [];
      //console.log("fetchFilterTransactions input", this.inputTransactions);
      //console.log("fetchFilterTransactions output", this.outputTransactions);
      if (this.selectedClients.length > 0 || this.selectedCategories.length > 0) {
        this.inputTransactions = [];
        //console.log("array clientes", this.clientsTemp);
        var widgetInputTemp = [];
        var widgetClientes = [];
        //var clientsId = [];
        //var categorieId = [];
        this.selectedClients.forEach(elementCat => {
          //console.log("elementCat", elementCat);
          this.clientsTemp.forEach(element => {
             if (elementCat === element.n) {
               //console.log("element.n temp", element.n);
                this.clientsId.push(element.id)
             } 
          });
        });
        //console.log("categorieId", categorieId);
        this.selectedCategories.forEach(elementCat => {
          //console.log("elementCat " + elementCat);
          this.responseInputFilter.forEach(element => {
            //console.log("element ", element.cat);
            if (elementCat === element.cat) {
              //console.log("elemento completo", element);
              widgetInputTemp.push(element);
              //let inputTemp = { responseInput: element }
              //widgetInputTemp.push(inputTemp);
            }
          });
        });
          this.clientsId.forEach(elementCliente => {
            //console.log("elementCat " + elementCat);
            this.responseInputFilter.forEach(element => {
              //console.log("element ", element.cat);
              if (elementCliente === element.cid) {
                //console.log("elemento completo", element);
                widgetClientes.push(element);
                //let inputTemp = { responseInput: element }
                //widgetInputTemp.push(inputTemp);
              }
            });
          });
          console.log("widgetInputTemp", widgetInputTemp);
          console.log("widgetClientes", widgetClientes);
          this.inputTransactions = widgetInputTemp.concat(widgetClientes);
          console.log("this.inputTransactions filtro", this.inputTransactions);
      } 
       
        
        
      
      if (this.selectedOutCategories.length > 0 || this.selectedAgents.length > 0) {
        //console.log("array agents", this.agentsTemp);
        this.outputTransactions = [];
        var widgetOutTemp = [];
        var widgetAgents = [];
       //var agentsId = [];
        this.selectedOutCategories.forEach(elementCat => {
          //console.log("elementCat out" + elementCat);
          this.responseOutputFilter.forEach(element => {
            //console.log("element cat", element.cat);
            if (elementCat === element.cat) {
              console.log("elemento completo", element);
              widgetOutTemp.push(element);
              
            }
          });
        });
        this.selectedAgents.forEach(elementCat => {
          //console.log("elementCat", elementCat);
          this.agentsTemp.forEach(element => {
             if (elementCat === element.n) {
               //console.log("element.n temp", element.n);
                this.agentsId.push(element.id)
             } 
          });
        });
        console.log("agentsId", this.agentsId);
      
        this.agentsId.forEach(elementAgents => {
          //console.log("elementCat " + elementCat);
          this.responseOutputFilter.forEach(element => {
            //console.log("element ", element.cat);
            if (elementAgents === element.aid) {
              //console.log("elemento completo", element);
              widgetAgents.push(element);
              //let inputTemp = { responseInput: element }
              //widgetInputTemp.push(inputTemp);
            }
          });
        });
        // console.log("widgetOutputTemp", widgetOutTemp);
        // console.log("widgetAgents", widgetAgents);
        this.outputTransactions = widgetOutTemp.concat(widgetAgents);
        // console.log("this.outputTransactions filtro", this.outputTransactions);
      }
      //this.createSuperArrays(sDate, eDate);
      this.fillSuperArraysInput();
      this.fillSuperArraysOutput();
      this.fillTableInputByPaymentMethod();
      this.fillTableByCategories();
      this.updateCharts();
      
    },
    fillTableDreFinanceiro() {
      //console.log("método para DRE");
      let widgetOutputByCategories = [];
      
      Object.entries(this.superArrayInputTransactions).forEach(by_categories => {
        //if (dayOutputCategories[0] === "total") {
        let dayInputCategories = by_categories;
        let categoriesTemp = dayInputCategories[1].by_categories;
        
        //let dayInputCategories = by_categories[1].by_categories;
           console.log("dayOutputCategories", dayInputCategories);
           console.log("elemento", categoriesTemp);
            
            //widgetOutputByCategories.push(dayInputCategories[1].by_categories);
             //console.log("widgetOutputByCategories", widgetOutputByCategories);
            //console.log("Entrada de Caixa",by_categories[1].by_categories['Entrada de Caixa'].total);
            //console.log("Investimento",by_categories[1].by_categories['Investimento'].total);
            //console.log("Outros",by_categories[1].by_categories['Outros'].total);
            //console.log("Vendas",by_categories[1].by_categories['Vendas'].total);
         //}
      });
      
      /** 
       * 
      Object.keys(this.superArrayInputTransactions).forEach(superKey => {
          if (this.superArrayInputTransactions[superKey].by_categories) {
            let dayOutputCategories = this.superArrayInputTransactions[superKey].by_categories;
            console.log("dayOutputCategories", dayOutputCategories);
            Object.entries(dayOutputCategories).forEach(dayOutputCategory => {
              let filteredpm = widgetOutputByCategories.find(
                pm => pm.label === dayOutputCategory[0]
              );
              filteredpm ? (filteredpm.value += dayOutputCategory[1].total) : "";
              console.log("filteredpm", filteredpm);
            });
          }
      });
      */
        /**

        * 
          if (by_categories[1].by_categories.hasOwnProperty("Entrada de Caixa")) {
            let totalEntradaCaixaTemp = by_categories[1].by_categories.hasOwnProperty("Entrada de Caixa").total;
            console.log("Entrada de Caixa", totalEntradaCaixaTemp);
          }
          
         */
        
        
    },
    
  },
 
  created() {
    //setting first day of current month as picker start date
    var firstDayOfMonth = new Date()
    firstDayOfMonth.setDate(1)
    this.formDate.startDate = firstDayOfMonth.toLocaleDateString('pt-BR').split('/').reverse().join('-')
    
    //setting today as picker end date
    var today = new Date()
    this.formDate.endDate = today.toLocaleDateString('pt-BR').split('/').reverse().join('-')
  },
};
</script>
<style>
.scroll {
  max-width: 1200px;
  min-height: 350px;
  overflow-y: auto;
}

</style>
